export default "__VITE_ASSET__Z6CAc1Rc__"